import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTipoDocumentoValidation]',
})
export class TipoDocumentoValidationDirective {
  @Input() allowedType: 'numbers' | 'alphanumeric' = 'numbers'; // El tipo permitido: 'numbers' o 'alphanumeric'

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let filteredValue = input.value;

    if (this.allowedType === 'numbers') {
      filteredValue = filteredValue.replace(/[^0-9]/g, ''); // Solo números
    } else if (this.allowedType === 'alphanumeric') {
      filteredValue = filteredValue.replace(/[^a-zA-Z0-9]/g, ''); // Solo alfanuméricos
    }

    this.ngControl.control?.setValue(filteredValue);
  }
}
